// extracted by mini-css-extract-plugin
export default {"icon":"Externalicon_icon__1AjCJ"};